var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"prefixes"},[_c('h2',[_vm._v("Number of top offending IP addresses:")]),_c('ul',{class:{ 'two-col': _vm.topIPs.length > 5 }},_vm._l((_vm.topIPs),function(ip){return _c('li',{key:ip.ip},[_c('span',{staticClass:"ip"},[_vm._v(_vm._s(ip.ip))]),_vm._v("\n      "+_vm._s(ip.count)+" hits\n    ")])}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }